<template>
    <div
        :class="['contentWrapper', wrapperClass]"
        :style="{
            'transition-duration': `${slideDuration}ms`,
            'grid-template-rows': transitionDisplay ? '1fr' : '0fr',
        }"
    >
        <div
            v-if="contentDisplay"
            :class="[$attrs.class]"
            :style="{ overflow: !isVisible ? 'hidden' : '' }"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VerticalSlideTransition',
    inheritAttrs: false,
    emit: ['canToggle'],

    props: {
        show: {
            type: Boolean,
            required: true,
        },
        keepAlive: {
            type: Boolean,
            default: false,
        },
        slideDuration: {
            type: Number,
            default: 350,
        },
        wrapperClass: {
            type: [String, Array, Object],
            default: '',
        },
    },

    data: () => ({
        transitionDisplay: false,
        contentDisplay: true,
        isVisible: false,
    }),

    mounted() {
        if (!this.keepAlive) {
            this.contentDisplay = this.show
        }
        this.transitionDisplay = this.show
        this.isVisible = this.show
    },

    watch: {
        show() {
            this.toggleShow()
        },
    },

    methods: {
        /**
         * Toggle the show state of the content
         *
         * @param contentDispay is used to keep the content in the dom
         * @param transitionDisplay is used to animate the content
         * @param isVisible is used to set overflow: hidden on the content during the transition and when its hidden,
         * is removed when the content is shown
         * That is needed to make the transition work
         */
        toggleShow() {
            if (this.show != this.contentDisplay || this.keepAlive) {
                this.$emit('canToggle', false)
                if (this.show) {
                    if (this.keepAlive) {
                        this.transitionDisplay = true
                        setTimeout(() => {
                            this.isVisible = true
                            this.$emit('canToggle', true)
                        }, this.slideDuration)
                    } else {
                        this.contentDisplay = true
                        this.$nextTick(() => {
                            this.transitionDisplay = true
                            setTimeout(() => {
                                this.isVisible = true
                                this.$emit('canToggle', true)
                            }, this.slideDuration)
                        })
                    }
                } else {
                    this.isVisible = false
                    this.transitionDisplay = false
                    setTimeout(() => {
                        this.$emit('canToggle', true)
                        if (!this.keepAlive) {
                            this.contentDisplay = false
                        }
                    }, this.slideDuration)
                }
            }
        },
    },
}
</script>

<style scoped>
.contentWrapper {
    display: grid;
    transition: grid-template-rows;
    transition-timing-function: ease;
}
</style>
